export const isBoolean = val => typeof val === 'boolean'
export const isString = val => typeof val === 'string'
export const isNumber = val => typeof val === 'number' && !isNaN(val)
